import React from "react";
import Page from "../templates/conserve/waste/wastepage";

export default function home() {
  return (
    <div>
      <Page />
    </div>
  );
}
